import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setTowns } from "@/src/store/filter";
import TownDropdown from "../location-checkbox-dropdown/towns-dropdown";
import { getLocalitiesAndTowns } from "services/location";
import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const TownsDropdown = () => {
  const [localitiesAndTown, setLocalitiesAndTown] = useState([]);
  const [inputText, setInputText] = useState("");
  const [isListboxOpen, setIsListboxOpen] = useState(false);

  const locationTowns = useSelector((state) => state.filter.towns);
  const locationDistricts = useSelector((state) => state.filter.districts);

  const dispatch = useDispatch();

  const fillTown = async () => {
    try {
      const arr = [];
      if (!locationDistricts || !Array.isArray(locationDistricts)) {
        return;
      }

      for (const district of locationDistricts) {
        const res = await getLocalitiesAndTowns(district?.id);
        if (res?.result) {
          arr.push({
            key: district.value || district.name,
            towns: res.result.map((item) => ({
              key: item.id,
              value: item.name,
              ...item,
            })),
          });
        }
      }
      setLocalitiesAndTown(arr);
    } catch (error) {
      console.error("Error for getCities callback from jetsat section!!!", error);
    }
  };

  const setReduxTown = (selected) => {
    const updatedTowns = locationTowns.some((town) => town.id === selected.id)
      ? locationTowns.filter((town) => town.id !== selected.id)
      : [...locationTowns, selected];

    dispatch(setTowns(updatedTowns));
  };

  const handleTownsChange = (selected, event) => {
    const isChecked = event.target.checked;

    if (selected.childs) {
      const newOrFilteredTowns = selected.childs.filter((child) =>
        isChecked
          ? !locationTowns.some((town) => town.id === child.id)
          : locationTowns.some((town) => town.id === child.id)
      );

      const updatedTowns = isChecked
        ? [...locationTowns, ...newOrFilteredTowns]
        : locationTowns.filter((town) => !newOrFilteredTowns.map(({ id }) => id).includes(town.id));

      dispatch(setTowns(updatedTowns));
    } else {
      setReduxTown(selected);
    }
  };

  const handleChildOptionChange = (e, selected) => {
    e.preventDefault();
    setReduxTown(selected);
  };

  useEffect(() => {
    fillTown();
  }, [locationTowns]);

  useEffect(() => {
    if (!isListboxOpen) {
      setInputText("");
    }
  }, [isListboxOpen]);

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleListBoxOpenState = (isOpen) => {
    setIsListboxOpen(isOpen);
  };

  const filteredDataForInput = localitiesAndTown
    ?.map((item) => {
      const lowerInputText = inputText.toLocaleLowerCase("tr-TR");

      const matchingTowns = item.towns
        ?.map((town) => {
          const townMatches = town.value?.toLocaleLowerCase("tr-TR").includes(lowerInputText);
          const matchingChilds = town.childs?.filter((child) =>
            child.name.toLocaleLowerCase("tr-TR").includes(lowerInputText)
          );

          if (townMatches || (matchingChilds && matchingChilds.length > 0)) {
            return {
              ...town,
              childs: townMatches ? town.childs : matchingChilds,
            };
          }

          return null;
        })
        .filter((town) => town !== null);

      if (matchingTowns && matchingTowns.length > 0) {
        return {
          ...item,
          towns: matchingTowns,
        };
      }

      if (item?.districtName?.toLocaleLowerCase("tr-TR").includes(lowerInputText)) {
        return item;
      }

      return null;
    })
    .filter((item) => item !== null);

  return (
    <div className={styles.dropdownWrapper}>
      <TownDropdown
        options={filteredDataForInput}
        placeHolder="Semt / Mahalle"
        placeHolderClass={styles.dropdownPlaceholder}
        disabled={!locationDistricts || locationDistricts?.length === 0}
        handleOptionChange={handleTownsChange}
        listClass={styles.townClass}
        optionClass={styles.optionClass}
        selectedItems={locationTowns}
        handleInputChange={handleInputChange}
        handleChildOptionChange={handleChildOptionChange}
        inputValue={inputText}
        onOpenChange={handleListBoxOpenState}
      />
    </div>
  );
};

export default TownsDropdown;
